export const GET_AUDITS_REQUEST = 'GET_AUDITS_REQUEST';
export const GET_AUDITS_SUCCESS = 'GET_AUDITS_SUCCESS';
export const GET_AUDITS_FAILURE = 'GET_AUDITS_FAILURE';

export const REVIEW_AUDIT_REQUEST = 'REVIEW_AUDIT_REQUEST';
export const REVIEW_AUDIT_SUCCESS = 'REVIEW_AUDIT_SUCCESS';
export const REVIEW_AUDIT_FAILURE = 'REVIEW_AUDIT_FAILURE';

export const CREATE_AUDIT_REQUEST = 'CREATE_AUDIT_REQUEST';
export const CREATE_AUDIT_SUCCESS = 'CREATE_AUDIT_SUCCESS';
export const CREATE_AUDIT_FAILURE = 'CREATE_AUDIT_FAILURE';

export const ASSIGN_AUDITS_REQUEST = 'ASSIGN_AUDITS_REQUEST';
export const ASSIGN_AUDITS_SUCCESS = 'ASSIGN_AUDITS_SUCCESS';
export const ASSIGN_AUDITS_FAILURE = 'ASSIGN_AUDITS_FAILURE';

export const DELETE_SIGNATORY_AUDITS_REQUEST = 'DELETE_SIGNATORY_AUDITS_REQUEST';
export const DELETE_SIGNATORY_AUDITS_SUCCESS = 'DELETE_SIGNATORY_AUDITS_SUCCESS';
